export const RICHTEXT_EDITOR_OPTIONS = {
  headings: [
    { label: 'Heading 1', value: '1' },
    { label: 'Heading 2', value: '2' },
    { label: 'Heading 3', value: '3' },
    { label: 'Heading 4', value: '4' },
    { label: 'Heading 5', value: '5' },
    { label: 'Heading 6', value: '6' }
  ],
  fontSizes: [
    { label: '12px', value: '12' },
    { label: '14px', value: '14' },
    { label: '16px', value: '16' },
    { label: '18px', value: '18' },
    { label: '20px', value: '20' },
    { label: '24px', value: '24' },
    { label: '28px', value: '28' },
    { label: '32px', value: '32' }
  ],
  fontColors: [
    { label: 'No Color', value: 'none' },
    { label: 'Primary', value: 'var(--color-primary)' },
    { label: 'Success', value: 'var(--color-success)' },
    { label: 'Warning', value: 'var(--color-warning)' },
    { label: 'Error', value: 'var(--color-error)' },
    { label: 'Info', value: 'var(--color-info)' },
    { label: 'Text', value: 'var(--color-text)' },
    { label: 'Text Secondary', value: 'var(--color-text-secondary)' },
    { label: 'Text Tertiary', value: 'var(--color-text-tertiary)' }
  ],
  bgColors: [
    { label: 'No Color', value: 'none' },
    { label: 'Primary BG', value: 'var(--color-primary-bg)' },
    { label: 'Success BG', value: 'var(--color-success-bg)' },
    { label: 'Warning BG', value: 'var(--color-warning-bg)' },
    { label: 'Error BG', value: 'var(--color-error-bg)' },
    { label: 'Info BG', value: 'var(--color-info-bg)' },
    { label: 'BG Container', value: 'var(--color-bg-container)' },
    { label: 'BG Elevated', value: 'var(--color-bg-elevated)' },
    { label: 'BG Layout', value: 'var(--color-bg-layout)' }
  ]
};

export const getRichTextEditorColorOptions = (token: any) => ({
  fontColors: [
    { label: 'No Color', value: 'none' },
    { label: 'Blue', value: token.colorPrimary },
    { label: 'Green', value: token.colorSuccess },
    { label: 'Orange', value: token.colorWarning },
    { label: 'Red', value: token.colorError },
    { label: 'Cyan', value: token.colorInfo },
    { label: 'Black', value: token.colorText },
    { label: 'Dark Gray', value: token.colorTextSecondary },
    { label: 'Light Gray', value: token.colorTextTertiary }
  ],
  bgColors: [
    { label: 'No Color', value: 'none' },
    { label: 'Dark Blue', value: token.colorWarning },
    { label: 'Dark Green', value: token.colorSuccessBorder },
    { label: 'Dark Orange', value: token.colorWarningBorder },
    { label: 'Dark Red', value: token.colorErrorBorder },
    { label: 'Dark Cyan', value: token.colorInfoBorder },
    { label: 'Gray', value: token.colorTextTertiary },
    { label: 'Dark Maroon', value: token.colorErrorActive },
    { label: 'Navy Blue', value: token.colorPrimaryActive }
  ]
});
